import React from 'react';

// Diagram of the Square of Health: four sides around the person, logo at the centre.
// Drawn for dark backgrounds.
const SquareOfHealth: React.FC = () => (
  <figure className="square-of-health">
    <svg viewBox="0 0 560 440" role="img" aria-labelledby="soh-title">
      <title id="soh-title">
        The Square of Health: Physical, Biochemical, Energy, and Mental &amp; Psychosocial, around you at the centre
      </title>
      <defs>
        <linearGradient id="soh-side" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2682be" />
          <stop offset="100%" stopColor="#963a7a" />
        </linearGradient>
      </defs>

      <rect x="160" y="100" width="240" height="240" fill="rgba(255,255,255,0.03)" stroke="url(#soh-side)" strokeWidth="3" />

      {[
        [160, 100],
        [400, 100],
        [400, 340],
        [160, 340],
      ].map(([cx, cy]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="6" fill="#963a7a" />
      ))}

      <image href="/icon@4x.png" x="235" y="175" width="90" height="90" />

      <g className="square-of-health__label">
        <text x="280" y="80" textAnchor="middle">Physical</text>
        <text x="420" y="227" textAnchor="start">Biochemical</text>
        <text x="280" y="376" textAnchor="middle">Energy</text>
        <text x="140" y="214" textAnchor="end">Mental &amp;</text>
        <text x="140" y="242" textAnchor="end">Psychosocial</text>
      </g>
    </svg>
  </figure>
);

export default SquareOfHealth;
